import { ShareholderIntervalPricing } from "./electronicGeneralMeetingDomain";
import { useTranslation } from "../../stores/RootStoreContext";
import { Dialog } from "../../components-v2/Dialog";
import { Box, VBox } from "../../components-v2/Box";
import { Markdown } from "../../text/Markdown";
import { Button } from "../../components-v2/Button";
import { openLiveGeneralMeetingReleaseNotes } from "../../utils/navigation";
import { observer } from "mobx-react";
import LiveGF from "../../assets/img/Live-GF.gif";
import { isMobileView } from "../../utils/screen";
import { TMessage } from "../../i18n/tt";

export const LiveGeneralMeetingAnnouncementDialog = observer(
  function LiveGeneralMeetingAnnouncementDialog({
    onClose,
    closeLabel,
    onSubmit,
    submitLabel,
    shareholderPricingInterval,
  }: {
    onClose: () => void;
    onSubmit?: () => void;
    closeLabel?: TMessage;
    submitLabel?: TMessage;
    shareholderPricingInterval?: ShareholderIntervalPricing;
  }) {
    const { t } = useTranslation();
    return (
      <Dialog
        fullscreen={isMobileView()}
        cancelLabel={closeLabel ?? t("close")}
        onCancel={onClose}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
      >
        <VBox textAlign={"center"} justifyContent={"center"} alignItems={"center"} gap={"lg"}>
          <img src={LiveGF} alt={"LiveGF"} />
          <h3>
            <Markdown value={t("release-announcement.general-meeting-title")} />
          </h3>
          <Markdown value={t("release-announcement.general-meeting-description")} />
          <Markdown
            value={t("release-announcement.general-meeting.price-per-meeting", {
              s: shareholderPricingInterval?.label ?? "",
              p:
                shareholderPricingInterval && shareholderPricingInterval.from === 100
                  ? shareholderPricingInterval.price
                  : `NOK ${shareholderPricingInterval?.price}`,
            })}
          />
          <div>
            <strong>{t("release-announcement.general-meeting.to-help")}</strong>
            <Markdown value={t("release-announcement.general-meeting.contact-us")} />
          </div>
          <Box vertical={isMobileView()}>
            <Button
              variant={"secondary"}
              label={t("release-announcement.general-meeting.product-sheet")}
              icon={"download"}
              onClick={() => openLiveGeneralMeetingReleaseNotes({ isProductSheet: true })}
            />
            <Button
              variant={"secondary"}
              label={t("release-announcement.general-meeting.participant-guide")}
              icon={"download"}
              onClick={() => openLiveGeneralMeetingReleaseNotes({ isProductSheet: false })}
            />
          </Box>
        </VBox>
      </Dialog>
    );
  },
);
